import { Link } from "wouter";

export function ClarityOneSessionRecovery({
  reason,
  onRetry,
  returnUrl,
  testId,
}: {
  reason: "error" | "timeout";
  onRetry: () => void;
  returnUrl?: string | null;
  testId: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center px-4" data-testid={testId}>
      <p className="text-lg font-medium text-[#1A2744] mb-2">Clarity One could not finish opening the customer view.</p>
      <p className="text-sm text-[#8B7355] leading-relaxed max-w-sm mb-8">
        {reason === "timeout"
          ? "The customer session took too long to load."
          : "The customer session could not be confirmed."}
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-xl bg-[#1A2744] hover:bg-[#243556] text-white px-6 py-2.5 text-sm font-medium"
          onClick={onRetry}
        >
          Retry
        </button>
        {returnUrl ? (
          <a
            href={returnUrl}
            className="inline-flex items-center justify-center rounded-xl border border-[#E8E4DC] text-[#1A2744] px-6 py-2.5 text-sm font-medium no-underline"
          >
            Return to customer card
          </a>
        ) : (
          <Link
            href="/login"
            className="inline-flex items-center justify-center rounded-xl border border-[#E8E4DC] text-[#1A2744] px-6 py-2.5 text-sm font-medium no-underline"
          >
            Go to Clarity One login
          </Link>
        )}
      </div>
    </div>
  );
}
